// hooks/useCategories.js
import { useState } from 'react';

export const useCategories = () => {
  const [categories, setCategories] = useState(null);
  const [totalCounts, setTotalCounts] = useState(0);

  return { categories, setCategories, totalCounts, setTotalCounts };
};
